export default __webpack_public_path__ + "fe0f151d8ccd3ded0c90436337112c96.png";